// Salvaged from ui-sprocket src/theme/colorMode.ts — reviewed 2026-09-21: unchanged apart from
// the `ColorMode` type now coming from tokens and the storage key moving to a constant here.
import { createContext, useContext } from 'react';
export const ColorModeContext = createContext({
    preference: 'system',
    mode: 'light',
    setPreference: () => { },
});
export function useColorMode() {
    return useContext(ColorModeContext);
}
/**
 * Stored globally rather than per tenant: a colour-mode choice is about the person's
 * eyes and their room, not about which workspace they happen to be looking at.
 */
export const COLOR_MODE_STORAGE_KEY = 'sprocket.colorMode';
export function readStoredPreference() {
    try {
        const stored = localStorage.getItem(COLOR_MODE_STORAGE_KEY);
        return stored === 'light' || stored === 'dark' || stored === 'system' ? stored : 'system';
    }
    catch {
        // Private browsing / blocked storage: follow the OS rather than failing.
        return 'system';
    }
}
export function writeStoredPreference(preference) {
    try {
        localStorage.setItem(COLOR_MODE_STORAGE_KEY, preference);
    }
    catch {
        // Non-fatal: the preference simply won't survive a reload.
    }
}
/** Resolve a preference to the mode that should actually render. */
export function resolveMode(preference, systemPrefersDark) {
    if (preference === 'system')
        return systemPrefersDark ? 'dark' : 'light';
    return preference;
}
//# sourceMappingURL=color-mode.js.map